import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  layout?: "vertical" | "horizontal";
}

const categoryLabel: Record<string, string> = {
  news: "新闻",
  activity: "活动",
  life: "生活",
};

export default function NewsCard({ item, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/detail/${item.id}`}
        className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200 rounded-lg p-3 md:p-4 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-full sm:w-56 h-40 sm:h-36 rounded-md overflow-hidden shrink-0 bg-background-100">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 小泽玛利亚资讯`}
            className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex flex-col min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-800 whitespace-nowrap">
              {categoryLabel[item.category]}
            </span>
            <span className="text-xs text-foreground-500">{item.date}</span>
          </div>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className="w-full h-48 md:h-52 overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 小泽玛利亚资讯`}
          className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2.5">
          <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-800 whitespace-nowrap">
            {categoryLabel[item.category]}
          </span>
          <span className="text-xs text-foreground-500">{item.date}</span>
        </div>
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">{item.summary}</p>
        <span className="mt-4 text-sm text-primary-700 flex items-center gap-1 whitespace-nowrap">
          阅读全文
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}